import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { BuyNeuroHub } from './BuyNeuroHub';


/**
 * @description Renders the subscriptions modal, with payment options, pricing and if
 * it's the case the 'not enough credits' and payment status possible steps.
 * The modal can be opened anywhere in the app using the **showUpgradeSubscriptionModal** function.
 */
export const BuyNeuroModal = NiceModal.create(({ targetAmount }: { targetAmount?: number }) => {
  // Use a hook to manage the modal state
  const modal = useModal();

  // Close modal
  const closeModal = () => {
    void modal.hide().then(() => modal.remove());
  };

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // *****************************************
  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      backdropClickDisabled
      size="sm"
      className="!max-w-fit"
      header={t('global.action.order')}
      body={<BuyNeuroHub closeModal={closeModal} targetAmount={targetAmount} />}
    />
  );
});

/**
 * @description Opens the buy neuro modal anywhere in the app.
 *
 * @example
 * import { showBuyNeuroModal } from '@components/features/modals/neuro/BuyNeuroModal';
 * // usage
 * <Button onClick={showBuyNeuroModal}>Buy neuro</Button>
 */
export const showBuyNeuroModal = (targetAmount?: number) => {
  void NiceModal.show(BuyNeuroModal, { targetAmount });
};
